import PhoneInput from 'react-phone-number-input';
import styled from 'styled-components';

export const StyledPhoneInput = styled(PhoneInput)`
  line-height: 1.5715;

  .PhoneInputCountry {
    padding: 4px 11px;
    border: #d6d6d6 1px solid;
    border-radius: 4px;
  }

  .PhoneInputCountryIcon {
    border-radius: 4px;
    border-color: #9d9d9d;
    margin-right: 0.2em;
    font-size: 1.3em;
  }

  .PhoneInputInput {
    border: ${(props) =>
      props.hasError ? 'red 1px solid' : '#D6D6D6 1px solid'};
    transition: 0.33s ease;
    padding: 4px 11px;
    color: #000;
    border-radius: 2px;

    &:hover {
      border-color: ${(props) => (props.hasError ? 'red' : '#40a9ff')};
    }

    &:focus {
      border-color: ${(props) => (props.hasError ? 'red' : '#40a9ff')};
      outline: 0;
      box-shadow: ${(props) =>
        props.hasError
          ? '0 0 0 2px rgba(255, 77, 79, .2)'
          : '0 0 0 2px rgb(24 44 255 / 20%)'};
    }
  }
`;
